import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { BottomNav } from "@/components/BottomNav";
import { useEngineSocket } from "@/hooks/useEngineSocket";
import Home from "@/pages/Home";
import Config from "@/pages/Config";
import Backtest from "@/pages/Backtest";
import Report from "@/pages/Report";
import Journal from "@/pages/Journal";
import Swing from "@/pages/Swing";

function App() {
  const { snapshot, connected } = useEngineSocket();

  return (
    <div className="dark App grid-bg min-h-screen text-white">
      <BrowserRouter>
        <div className="max-w-md mx-auto min-h-screen relative">
          <Routes>
            <Route path="/" element={<Home snapshot={snapshot} connected={connected} />} />
            <Route path="/swing" element={<Swing />} />
            <Route path="/config" element={<Config />} />
            <Route path="/backtest" element={<Backtest />} />
            <Route path="/report" element={<Report />} />
            <Route path="/journal" element={<Journal />} />
          </Routes>
          <BottomNav />
        </div>
        <Toaster
          theme="dark"
          position="top-center"
          toastOptions={{
            style: { background: "#11141A", border: "1px solid #222630", color: "#fff", fontFamily: "Outfit" },
          }}
        />
      </BrowserRouter>
    </div>
  );
}

export default App;
